import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { DecisionButtonText } from 'components/project/ClerkScreen';
import { DecisionButton, HotKeyLabel } from '../Styles';

const NoSaleButton = () => {
  const {
    BidStore: { auction, disableAskingBid, laneSuspended },
    UIStore: { handleDecisionClick, getHotKey },
  } = useStores();

  const key = auction.firstDecisionClick;
  const buttonText = 'No Sale';
  const saleType = 'NoSale';
  const buttonWasFirstClicked = key === saleType && laneSuspended;

  return (
    <>
      <DecisionButton
        isFirstClick={buttonWasFirstClicked}
        invalid={false}
        disabled={disableAskingBid}
        onClick={() => handleDecisionClick(saleType)}
        tabIndex={8}
        color="#FFFFFF"
        bgColor="#DB2828"
        firstClick={buttonWasFirstClicked}
        bgVariance={50}
        data-testid="nosale-btn"
      >
        <DecisionButtonText confirming={laneSuspended} text={buttonText} />
        <HotKeyLabel color="white">
          {getHotKey('target', 'NO SALE').label}
        </HotKeyLabel>
      </DecisionButton>
    </>
  );
};

export default observer(NoSaleButton);
